<template>
    <div class="announcement-popup-vue">
        <div
            class="modal-backdrop fade show"
            v-if="visible"
        ></div>
        <div
            v-if="visible"
            :id="modalId"
            class="modal bo-modal"
            tabindex="-1"
            role="dialog"
            :aria-labelledby="modalId"
            style="display: block"
        >
            <div
                class="success modal-dialog modal-dialog-centered"
                role="document"
            >
                <div class="modal-content">
                    <button
                        type="button"
                        class="announcement-close-btn"
                        aria-label="Close"
                        @click="deactivate"
                    >
                        <i class="icon-close"></i>
                    </button>

                    <div
                        class="modal-body mt-4 pt-0"
                        style="height: 60vh; overflow-y: auto"
                    >
                        <slot name="body-content"></slot>
                    </div>

                    <div class="modal-footer">
                        <div class="footer-content">
                            <div class="side-info">
                                <span v-if="rowCounts > 1">{{ pageCount }}</span>

                                <button
                                    v-if="rowCounts > 1"
                                    type="button"
                                    class="nav-btn footer-nav-btn"
                                    :disabled="currentIndex <= 0"
                                    @click="previousPage"
                                >
                                    <i class="icon-chevronleft"></i>
                                </button>

                                <button
                                    v-if="rowCounts > 1"
                                    type="button"
                                    class="nav-btn footer-nav-btn"
                                    :disabled="currentIndex >= rowCounts - 1"
                                    @click="nextPage"
                                >
                                    <i class="icon-chevronright"></i>
                                </button>
                            </div>

                            <div class="button-groups">
                                <button
                                    type="button"
                                    id="confirm_button"
                                    class="btn-rounded"
                                    @click="triggerAction"
                                >
                                    {{ generalTranslations.discover_more ?? "Discover More" }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
import vClickOutside from "v-click-outside";
import Vue from "vue";
Vue.use(vClickOutside);

const defaultFunction = () => {};

export default {
    props: {
        id: {
            type: String,
            default: null,
        },
        active: {
            type: Boolean,
            default: false,
        },
        rowCounts: {
            type: Number,
            default: 0,
        },
        currentIndex: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            visible: this.active,
            navInputLocked: false,
            navInputTimeoutMs: 180,
            navInputTimeoutId: null,
            vcoConfig: {
                handler: this.deactivate,
            },
            generalTranslations: window?.bo?.generalTranslations ?? {},
        };
    },
    computed: {
        modalId: {
            get() {
                return this.id ?? `bo-popup-modal_${uuidv4()}`;
            },
        },
        pageCount: {
            get() {
                if (!this.rowCounts) return "";
                return `${this.currentIndex + 1} / ${this.rowCounts}`;
            },
        },
    },
    watch: {
        active: function (n, o) {
            this.visible = n;
        },
        visible: function (n, o) {
            this.$emit(n ? "activate" : "deactivate");
        },
    },
    methods: {
        activate() {
            this.visible = true;
            document.body.classList.add("modal-open");
            this.$emit("activate");
        },
        deactivate() {
            this.visible = false;
            document.body.classList.remove("modal-open");
            this.$emit("deactivate");
        },
        triggerAction() {
            this.$emit("trigger");
        },
        canNavigate() {
            if (this.navInputLocked) return false;

            this.navInputLocked = true;
            if (this.navInputTimeoutId) {
                clearTimeout(this.navInputTimeoutId);
            }

            this.navInputTimeoutId = setTimeout(() => {
                this.navInputLocked = false;
                this.navInputTimeoutId = null;
            }, this.navInputTimeoutMs);

            return true;
        },
        previousPage() {
            if (!this.canNavigate()) return;

            if (this.currentIndex > 0) {
                this.$emit("previous");
            }
        },
        nextPage() {
            if (!this.canNavigate()) return;

            if (this.currentIndex < this.rowCounts - 1) {
                this.$emit("next");
            }
        },
    },
    beforeDestroy() {
        if (this.navInputTimeoutId) {
            clearTimeout(this.navInputTimeoutId);
            this.navInputTimeoutId = null;
        }
    },
};
</script>
